import { css } from '@emotion/react';
import React from 'react';

import { mediaQueries } from '~src/theme/mediaQueries';

export const LogoInlineWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div css={styles.outerWrapper}>
      <div css={styles.innerWrapper}>{children}</div>
    </div>
  );
};

const styles = {
  outerWrapper: css({
    position: 'relative',
    display: 'flex',
    width: '32px',
    height: '32px',
  }),
  innerWrapper: css({
    position: 'absolute',
    top: '-6px',
    height: '32px',
    width: '32px',
    overflow: 'hidden',
    [mediaQueries.S]: {
      top: 0,
    },
  }),
};
